export default __webpack_public_path__ + "static/media/March2009.33d2b10f.png";